import React, { useState } from "react";
import { Select, Input } from "antd";

const getRecipients = expense => {
  const recipients = [expense.user_fullname];
  if (expense.processed && expense.processed_by && expense.processed_by.user_fullname) {
    recipients.push(expense.processed_by.user_fullname);
  }

  return recipients;
};
const Option = Select.Option;
const { TextArea } = Input;
export const Reject = ({ rejectTypes = [], expense, reject }) => {
  const defaultType = rejectTypes[0] || {};
  const [rejectedInfos, setRejectedInfos] = useState({
    comment: "",
    recipients: getRecipients(expense),
    type: {
      id: defaultType.id,
      label: defaultType.label
    }
  });

  return (
    <div className="p-2" style={{ background: "ligthgrey", width: "100%", border: "1px solid black" }}>
      <div className="flex flex-col my-4">
        <span className="my-1 mx-2 font-bold">MOTIF DU REFUS :</span>
        <Select
          placeholder=""
          value={rejectedInfos && rejectedInfos.type && rejectedInfos.type.id}
          onChange={typeSelectedId => {
            setRejectedInfos({
              ...rejectedInfos,
              type: {
                id: typeSelectedId,
                label: rejectTypes.find(item => item.id === typeSelectedId).label
              }
            });
          }}
        >
          {rejectTypes.map(type => (
            <Option key={type.id} value={type.id}>
              {type.label}
            </Option>
          ))}
        </Select>
      </div>
      <div className="flex flex-col my-4">
        <span className="my-1 mx-2 font-bold">Commentaire :</span>
        <TextArea
          rows={4}
          value={rejectedInfos && rejectedInfos.comment}
          onChange={e => setRejectedInfos({ ...rejectedInfos, comment: e.target.value })}
        />
      </div>
      <div className="flex flex-col my-4">
        <span className="my-1 mx-2 font-bold">Destinataire :</span>
        <div className="m-2">{rejectedInfos && JSON.stringify(rejectedInfos.recipients)}</div>
      </div>
      <div
        className="mt-12 flex justify-center cursor-pointer px-6 py-2 mx-2 leading-5 rounded-full bg-red-500 text-white"
        style={{ fontSize: 20, padding: 20 }}
        onClick={() => reject({ _id: expense._id, rejected_infos: rejectedInfos })}
      >
        Rejeter la note de frais
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// src/modules/presence/expenseReports/Accounting/components/Reject.component.js